import React from "react";
import styled from "styled-components";

export interface ScrollerProps {
  content: any;
  height: string;
}

const Scroll = styled.div`
  overflow: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #dbdbdb;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background: #dbdbdb;
    border-radius: 10px;
  }
`;

const Scroller: React.FC<ScrollerProps> = ({ content, height }) => (
  <Scroll style={{ maxHeight: height }}>{content}</Scroll>
);

export default Scroller;
